import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const CHAT_READ_EVENT = "client-chat-read";

export function useChatUnread(enabled = true) {
  const [d, setD] = useState({ total: 0, by_client: {} });
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => api.get("/client-chat/unread").then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    window.addEventListener(CHAT_READ_EVENT, load);
    return () => { clearInterval(t); window.removeEventListener(CHAT_READ_EVENT, load); };
  }, [enabled]);
  return d;
}
